import { IconButton, IconButtonProps } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

const SquareIconButton: React.FC<IconButtonProps> = ({
  children,
  className,
  ...props
}) => (
  <IconButton
    className={cn('bg-brand-navy! rounded! p-2! text-white!', className)}
    {...props}
  >
    {children}
  </IconButton>
);

export default SquareIconButton;
